/**
 * Which table you are sitting at.
 *
 * Three cloths, not three colour schemes. The rest of the room does not
 * change: a player picking the blue table over the green one is choosing where
 * to sit, the way they would in a card room, not asking for a different
 * product. So this is one attribute on the felt and nothing else.
 *
 * Remembered per browser rather than per account. It is a preference about
 * this screen — the same person on a phone in a bright room and a desk at
 * night may reasonably want different answers, and neither is worth a round
 * trip to the server.
 */

export const FELTS = ['emerald', 'midnight', 'claret'] as const;
export type Felt = (typeof FELTS)[number];

export const FELT_LABEL: Record<Felt, string> = {
  emerald: 'Emerald',
  midnight: 'Midnight',
  claret: 'Claret',
};

const STORAGE_KEY = 'pf-felt';

function isFelt(value: string | null): value is Felt {
  return value !== null && (FELTS as readonly string[]).includes(value);
}

export function feltChoice(): Felt {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isFelt(stored) ? stored : 'emerald';
  } catch {
    // A browser with storage switched off still gets a table to sit at.
    return 'emerald';
  }
}

export function setFeltChoice(felt: Felt): void {
  try {
    localStorage.setItem(STORAGE_KEY, felt);
  } catch {
    // Not worth interrupting a hand over.
  }
}

/** The next one round, so the control can be one button rather than three. */
export function nextFelt(current: Felt): Felt {
  return FELTS[(FELTS.indexOf(current) + 1) % FELTS.length] as Felt;
}
